import {
  UpdatePageElementsPayload,
  type PageElementsResponse,
} from "@/interfaces/element.interface";
import { ApiQueryParams, apiRequest } from "../Api";

export interface UpdatePageElementsResponse {
  success: boolean;
  message: string;
  data: { id: string };
  execution_time: number;
  cached: boolean;
  timestamp: string;
}

export const updatePageElements = (
  websiteInterfaceId: string,
  params: ApiQueryParams,
  data: UpdatePageElementsPayload,
) =>
  apiRequest<{ data: UpdatePageElementsPayload }, UpdatePageElementsResponse>({
    url: `/entities/update/${websiteInterfaceId}`,
    scope: 'page_element',
    method: 'PUT',
    params,
    data: { data },
  });
